export const CParentsErrorsTitles = {
    TEEN_TRANSACTIONS: 'Parents API - Get Teen Transactions',
    LAST_TEEN_TRANSACTIONS: 'Parents API - Get Last Teen Transactions',
    GET_TEENS_MENU: 'Parents - Get Teens for Menu',
} as const;